import { Fragment, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store/store';
import { ToastContainer } from 'react-toastify';
import { ROLES } from './utils/roles';
import './css/style.css';
import Home from './components/home/Home';
import Perfil from './components/perfil/Perfil';
import LoadingOverlay from './components/secondary/LoadingOverlay';
import AuthBootstrapper from './components/secondary/AuthBootstrapper';
import ProtectedRoute from './components/secondary/ProtectedRoute';
import ProgramarCorreo from './components/correos/ProgramarCorreo';
import MisCorreos from './components/correos/MisCorreos';
import Viajes from './components/viajes/Viajes';
import ViajesCompletados from './components/viajes/ViajesCompletados';
import Ideas from './components/ideas/Ideas';
import IdeasCompletadas from './components/ideas/IdeasCompletadas';
import GaleriaFotos from './components/galeria/GaleriaFotos';
import Contacto from './components/contacto/Contacto';
import Recetas from './components/recetas/Recetas';
import CalculadoraForex from './components/calculadora-compra/CalculadoraForex';
import GanadorAleatorio from './components/ganador-aleatorio/GanadorAleatorio';
import SopaDeLetras from './components/sopa-de-letras/SopaDeLetras';
import Ranking from './components/ranking/Ranking';
import Navbar from './components/navbar/Navbar';
import GenerarEquipos from './components/generador-equipos/GenerarEquipos';
import EstadisticasRecetas from './components/recetas/EstadisticasRecetas';
import DiarioTrading from './components/diario-trading/DiarioTrading';
import ListaCompra from './components/lista-compra/ListaCompra';
import Contador from './components/contador/Contador';
import ContadorLogs from './components/contador/ContadorLogs';
import NuestroTiempo from './components/nuestro-tiempo/NuestroTiempo';
import UsuariosPendientes from './components/admin/UsuariosPendientes';
import HeatmapPage from './components/contador/HeatmapPage';
import ContadorStats from './components/contador/ContadorStats';
import Gym from './components/control-de-pesos/Gym';
import CalculadoraRaciones from './components/calculadora-raciones/CalculadoraRaciones';
import CalculadoraLucid from './components/calculadora-lucid/CalculadoraLucid';
import CalculadoraContratos from './components/calculadora-contratos/CalculadoraContratos';

export default function AppV2() {
    const darkMode = useSelector((state: RootState) => state.theme.darkMode);
    const loading = useSelector((state: RootState) => state.loading.loading);

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add("dark");
        } else {
            document.body.classList.remove("dark");
        }
    }, [darkMode]);

    return (
        <Fragment>
            {loading && <LoadingOverlay />}
            <AuthBootstrapper />
            <BrowserRouter>
                <Navbar />
                <div className="contenido-app-v2">
                    <Routes>
                        <Route path="*" element={<Navigate to="/" replace />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/inicio" element={<Home />} />
                        <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />
                        <Route path="/correos" element={<ProgramarCorreo />} />
                        <Route path="/mis-correos" element={<ProtectedRoute><MisCorreos /></ProtectedRoute>} />
                        <Route path="/viajes" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Viajes /></ProtectedRoute>} />
                        <Route path="/viajes-completados" element={<ProtectedRoute requiredRole={ROLES.A12_B}><ViajesCompletados /></ProtectedRoute>} />
                        <Route path="/ideas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Ideas /></ProtectedRoute>} />
                        <Route path="/ideas-completadas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><IdeasCompletadas /></ProtectedRoute>} />
                        <Route path="/galeria" element={<ProtectedRoute requiredRole={ROLES.A12_B}><GaleriaFotos /></ProtectedRoute>} />
                        <Route path="/contacto" element={<Contacto />} />
                        <Route path="/recetas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Recetas /></ProtectedRoute>} />
                        <Route path="/calculadora-forex" element={<CalculadoraForex />} />
                        <Route path="/calculadora-contratos" element={<CalculadoraContratos />} />
                        <Route path="/ganador-aleatorio" element={<GanadorAleatorio />} />
                        <Route path="/sopa-de-letras" element={<ProtectedRoute requiredRole={ROLES.A12_B}><SopaDeLetras /></ProtectedRoute>} />
                        <Route path="/ranking" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Ranking /></ProtectedRoute>} />
                        <Route path="/generar-equipos" element={<GenerarEquipos />} />
                        <Route path="/estadisticas-recetas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><EstadisticasRecetas /></ProtectedRoute>} />
                        <Route path="/diario-trading" element={<ProtectedRoute requiredRole={ROLES.A12_B}><DiarioTrading /></ProtectedRoute>} />
                        <Route path="/lista-compra" element={<ProtectedRoute requiredRole={ROLES.A12_B}><ListaCompra /></ProtectedRoute>} />
                        <Route path="/contador" element={<ProtectedRoute requiredRole={ROLES.A12_B} requireAdminWT><Contador /></ProtectedRoute>} />
                        <Route path="/contador/logs" element={<ProtectedRoute requiredRole={ROLES.A12_B} requireAdminWT><ContadorLogs /></ProtectedRoute>} />
                        <Route path="/nuestro-tiempo" element={<ProtectedRoute requiredRole={ROLES.A12_B}><NuestroTiempo /></ProtectedRoute>} />
                        <Route path="/admin/usuarios" element={<ProtectedRoute requiredRole={ROLES.A12_B}><UsuariosPendientes /></ProtectedRoute>} />
                        <Route path="/contador/mapa-de-calor" element={<ProtectedRoute requiredRole={ROLES.A12_B} requireAdminWT><HeatmapPage /></ProtectedRoute>} />
                        <Route path="/contador/stats" element={<ProtectedRoute requiredRole={ROLES.A12_B} requireAdminWT><ContadorStats /></ProtectedRoute>} />
                        <Route path="/control-pesos" element={<ProtectedRoute><Gym /></ProtectedRoute>} />
                        <Route path="/calculadora-raciones" element={<CalculadoraRaciones />} />
                        <Route path="/calculadora-lucid" element={<CalculadoraLucid />} />


                    </Routes>
                </div>
            </BrowserRouter>
            <ToastContainer
                position="top-right"
                autoClose={2500}
                newestOnTop
                theme="light"
            />
        </Fragment>
    );
}
